// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Jnt2","actions":"GroupTable_actions__37fVw","deleteModalFooter":"GroupTable_deleteModalFooter__1FpZo"};